import { render, staticRenderFns } from "./CreditLedger.vue?vue&type=template&id=64cb08bf&scoped=true&"
import script from "./CreditLedger.vue?vue&type=script&lang=js&"
export * from "./CreditLedger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cb08bf",
  null
  
)

export default component.exports